export default __webpack_public_path__ + "49f639bace347116257d581d244f136a.png";